var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const getProductsByTag = (tag, isoCode, handle, sort_key, reverse) => __awaiter(void 0, void 0, void 0, function* () {
    const storeData = window.thGeolocationData.stores.find((store) => {
        return store.permanent_domain === window.Shopify.shop;
    });
    if (storeData) {
        return yield fetch(`https://threadheads-admin-api-56b7d3006b0b.herokuapp.com/products-by-tag/${window.threadheads.adminApiRegion}/${tag}/${isoCode}/${sort_key}/${reverse}`)
            .then((res) => {
            return res.json();
        })
            .then((data) => {
            const products = data.body.data.products.edges;
            if (products.length < 1)
                return null;
            const filtered = products.filter((product) => product.node.handle !== handle && !product.node.tags.includes('in_private_collection') && !product.node.tags.includes('hidden'));
            if (filtered.length > 0) {
                return filtered;
            }
        });
    }
    return null;
});
